<template>
  <div>
    <div>
      <div v-show="errorText !== ''" v-html="errorText" class="alert alert-danger" role="alert">
        {{errorText}}
      </div>
      <div v-show="successText !== ''" class="alert alert-success" role="alert">
        {{successText}}
      </div>
    </div>
    <moon-loader :loading="inProgress" color="#666" size="30px"></moon-loader>
    <b-row>
      <b-col>
        <p>{{$t('Actualizar marcas')}}</p>
        <b-button :disabled="inProgress || disableBrands" class="float-left ml-5 pr-5 pl-5" @click="migrate('brands')" variant="primary">{{$t('Actualizar')}}</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col  class="mt-5">
        <p>{{$t('Actualizar categorías')}}</p>
        <b-button :disabled="inProgress || disableCategories" class="float-left ml-5 pr-5 pl-5" @click="migrate('categories')" variant="primary">{{$t('Actualizar')}}</b-button>
      </b-col>
    </b-row>
  </div>
  </template>
  
  <script>
  import appConfig from '@/config/applicationConfig.js'
  import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
  import {ProductServiceMixim} from '@/mixims/ProductServiceMixim.js'
  
  export default {
    name: 'category-and-brand-updater',
    components: {
      MoonLoader
    },
    mixins: [ProductServiceMixim],
    methods: {
      migrate (item) {
        this.inProgress = true
        this.errorText = ''
        this.successText = ''
        let endpoint = `${appConfig.API_END_POINT}/${item}/migrate`
  
        return this.$http.post(endpoint, {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.access_token}`
            }
          }
        ).then(
          () => {
            this.inProgress = false
            this.successText = `${this.$t('La actualización de')} ${item === 'brands' ? this.$t('Marcas') : this.$t('Categorías')} ${this.$t('ha comenzado, validar en 15 minutos (aprox.)')}`
            if (item === 'brands') {
              this.disableBrands = true
            } else {
              this.disableCategories = true
            }
          },
          (error) => {
            this.inProgress = false
            this.errorText = error.body.message || `${this.$t('Error migrando los datos para')} ${item === 'brands' ? this.$t('Marcas') : this.$t('Categorías')} ${this.$t('a Seller Center')}`
          }
        )
      }
    },
    data () {
      return {
        inProgress: false,
        successText: '',
        errorText: '',
        disableBrands: false,
        disableCategories: false
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  </style>